import React from "react"

export function ProfileFormPage() {
    return <></>
}